import React from 'react'
function BannerInfo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      <h2 className="card-title">ORGANISMOS PARTICIPANTES</h2>
      <p className="card-text">
      Este proyecto busca fortalecer los lazos de cooperación entre las diferentes áreas
de Gobierno, ayudando a que toda la información geoespacial producida a partir de los
distintos actores tenga la posibilidad de ser disponibilizada y consultada, sin importar las capacidades técnicas de cada sector para lograr su publicación. Es por eso que, se
convoca a todos los sectores a ser parte de esta IDECABA.<br/><br/>
En este sentido, el equipo de la GOED-DGGD trabaja activamente en este proyecto,
siendo los responsables de diseñar, administrar e integrar las bases de datos
georreferenciadas provenientes de la gran mayoría de áreas del GCBA. Asímismo, se
encarga de la definición de normas de calidad y estandarización de la información
geográfica y la administración de los medios donde se publica
      </p>
    </div>
  </div>
</div>

  )
}

export default BannerInfo